import * as Yup from 'yup'

const validateLogin = Yup.object({
  email: Yup.string()
    .email('Dirección de mail inválida')
    .required('Obligatorio'),
  ...(process.env.REACT_APP_DEVELOPMENT !== 'TRUE' && {
    password: Yup.string()
      .min(8, 'Debe tener al menos 8 caracteres')
      .required('Obligatorio'),
  }),
})

export default validateLogin
